import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "./networkService";

export async function getTransactions(userEmail: string){
    const response = await ChannelkartNetworkGet(`/v1/checkmate/transactions/${userEmail}`);
    return response.data;
}

export async function executeQueryWithId(id: string){
    const response = await ChannelkartNetworkPost(`/v1/checkmate/transactions/execute/${id}`, id);
    return response.data;
}

export async function requestRollbackWithId(id: string){
    const response = await ChannelkartNetworkPost(`/v1/checkmate/transactions/raiseRollback/${id}`, id);
    return response.data;
}

export async function executeRollbackWithId(id: string){
    const response = await ChannelkartNetworkPost(`/v1/checkmate/transactions/rollback/${id}`, id);
    return response.data;
}

export async function fetchDataForTable(selectedOption: string, offset: number, limit: number){
    const response = await ChannelkartNetworkGet(`/v1/checkmate/fetchTable/${selectedOption}?offset=${offset}&limit=${limit}`);
    return response;
}

export async function fetchCountForTable(tableName: string){
    const response = await ChannelkartNetworkGet(`/v1/checkmate/fetchCount/${tableName}`);
    return response;
}

export async function raiseRequest(payload: any){
    const response = await ChannelkartNetworkPost(`/v1/checkmate/transaction/raiseRequest`, payload);
    return response.data;
}